import { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";

function VerifyEmail() {
	const { token } = useParams();
	const navigate = useNavigate();

	const [status, setStatus] = useState("verifying"); // "verifying" | "success" | "error"
	const [message, setMessage] = useState("Verifying your email…");
	const calledRef = useRef(false); // guard against React 18 StrictMode double-invoke

	useEffect(() => {
		if (calledRef.current) return;
		calledRef.current = true;

		const verify = async () => {
			try {
				const res = await fetch(
					`https://backend-global-1vq9.onrender.com/api/auth/verify-email/${token}`,
					{ method: "GET", headers: { "Content-Type": "application/json" } }
				);
				const data = await res.json().catch(() => ({}));

				if (!res.ok) {
					setStatus("error");
					setMessage(data.message || data.msg || "Invalid or expired verification link.");
					return;
				}

				setStatus("success");
				setMessage(data.message || "Email verified successfully. You can now log in.");
			} catch (err) {
				setStatus("error");
				setMessage("Something went wrong while verifying. Please try again.");
			}
		};

		verify();
	}, [token]);

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100vh",
				alignItems: "center",
				justifyContent: "center",
				background: "linear-gradient(180deg, #E6F7FD, #FFFFFF)",
				padding: "20px",
			}}
		>
			<div
				style={{
					maxWidth: 420,
					width: "100%",
					background: "#fff",
					border: "1px solid #E6E6E6",
					borderRadius: 12,
					padding: "32px 24px",
					textAlign: "center",
					boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
				}}
			>
				<h2 style={{ color: "#00AEEF", marginBottom: 12 }}>
					{status === "verifying"
						? "Verifying…"
						: status === "success"
						? "Email Verified"
						: "Verification Failed"}
				</h2>

				<p style={{ color: "#555", fontSize: 14, lineHeight: 1.6, marginBottom: 24 }}>
					{message}
				</p>

				{status === "success" && (
					<button
						onClick={() => navigate("/login")}
						style={{
							background: "linear-gradient(180deg, #6BD0F6, #0A2E8A)",
							border: "none",
							borderRadius: 8,
							padding: "12px 24px",
							color: "#fff",
							fontWeight: "bold",
							fontSize: 15,
							cursor: "pointer",
							width: "100%",
						}}
					>
						Go to Login
					</button>
				)}

				{status === "error" && (
					<button
						onClick={() => navigate("/login")}
						style={{
							background: "#fff",
							border: "1px solid #00AEEF",
							borderRadius: 8,
							padding: "12px 24px",
							color: "#00AEEF",
							fontWeight: "bold",
							fontSize: 15,
							cursor: "pointer",
							width: "100%",
						}}
					>
						Back to Login
					</button>
				)}
			</div>
		</div>
	);
}

export default VerifyEmail;